import { render, staticRenderFns } from "./zuanti.vue?vue&type=template&id=1428c29d&scoped=true&"
import script from "./zuanti.vue?vue&type=script&lang=js&"
export * from "./zuanti.vue?vue&type=script&lang=js&"
import style0 from "./zuanti.vue?vue&type=style&index=0&id=1428c29d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1428c29d",
  null
  
)

export default component.exports